import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DifferenceSelectorWrapper = styled.div`
  margin: ${Spacing.S16} 0;
  padding: ${Spacing.S12} ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Grey100};
`
